module.exports = __webpack_public_path__ + "img/logo-print-3.6c8b9b69.png";